export default __webpack_public_path__ + "static/media/cemea-formation.d4e6d9ca.png";